import React,{ useState, useEffect } from "react";
import { 
    Form, 
    Button, 
    Input,
    Alert
} from 'antd';
import axios from 'axios';

function CartTotals( { 
    cartItems, 
    cartTotals, 
    cartData,
    paymentReceived } ) {

    const [couponInputValid, setCouponInputValid] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [appliedCouponCode, setAppliedCouponCode] = useState('Promo code');
    const [couponApplied, setCouponApplied] = useState(false);
    const [couponAlertMarkup, setCouponAlertMarkup] = useState(<></>);
    const [couponProcessing, setCouponProcessing] = useState(false);
    const [form] = Form.useForm();
    const siteDomain = headerVars.siteDomain;

    useEffect(() => {
        if( cartData.length ) {
            for( var i=0; i < cartData.length; i++ ) {
                if( cartData[i].applied_coupon ) {
                    setAppliedCouponCode( cartData[i].applied_coupon );
                    setCouponApplied( true );
                } else {
                    setAppliedCouponCode( 'Promo code' );
                    setCouponApplied( false );
                }
            }
        }

    },[ cartData,
        cartItems
    ])

    const onCouponInputChange = ( e ) => {
        let currentVal = e.target.value;
        let inputID = e.target.id;

        //console.log( 'currentVal: ', currentVal.length );

        if( currentVal.length > 3 ) {
            setCouponInputValid( true );
            setCouponCode( currentVal );
        } else {
            setCouponInputValid( false );
        }
    }

    const handleValidateCouponCode = () => {
        let requestUrl = {ajax_url : siteDomain+"/wp-admin/admin-ajax.php"};
        let form_data = new FormData;
        form_data.append('action', 'apply_coupon_code_to_order');
        form_data.append('coupon_code', couponCode );
        setCouponProcessing( true );

        axios
        .post(requestUrl.ajax_url, form_data)
        .then(function(response){
            //console.log(response.data);
            setCouponProcessing( false );

            switch( response.data ) {
                case "coupon-applied":
                document.dispatchEvent(new CustomEvent('cartUpdateState', { detail: '' }));
                setCouponAlertMarkup( 
                    <Alert
                        message="Coupon applied"
                        description=""
                        type="success"
                        showIcon
                        closable
                    />
                );
                break;
                case "duplicate-attempt":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon has already been applied."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "invalid-coupon":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon does not exist."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "missing-internet":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon requires an internet service package in your cart."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "missing-tv":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon requires a television service package in your cart."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "coupon-not-applicable":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon is not applicable for your selected services."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "internet-used":
                setCouponAlertMarkup( 
                    <Alert
                        message="Only one coupon for internet services is allowed."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "tv-used":
                setCouponAlertMarkup( 
                    <Alert
                        message="Only one coupon for television services is allowed."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "invalid-employee-id":
                setCouponAlertMarkup( 
                    <Alert
                        message="The employee id associated with this coupon is invalid."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
                case "invalid-product":
                setCouponAlertMarkup( 
                    <Alert
                        message="This coupon is not valid with any items in your cart."
                        description=""
                        type="error"
                        showIcon
                        closable
                    />
                );
                break;
            }
        })
        .catch(function (error) {
            console.log(error);
            setCouponProcessing( false );
            setCouponAlertMarkup( 
                <Alert
                    message="Please enter a valid coupon code."
                    description=""
                    type="error"
                    showIcon
                    closable
                />
            );
        })
        .finally(function () {
            // always executed
        });
    }

    return ( 
        <div className="cart-totals-container">
            <div className='order-summary-h2'>
                Order Summary
            </div>
            <div className="cart-items-container">
                <div className="cart-items">{ cartItems }</div>
                <Form
                    form={ form }
                    style={ { 'display': ( ( cartItems.length >= 2 ) && !paymentReceived ) ? 'block' : 'none' } }
                >
                    <div className="form-column-row">
                        <Form.Item
                            label=""
                            labelCol={{ span: 24 }}
                            name="coupon-input"
                            style={{marginBottom:'1rem', width:'100%'}}
                            rules={[
                                {
                                required: false,
                                message: '',
                                },
                            ]}
                        >
                            <Input
                                id="coupon-input"
                                name="coupon-input"
                                disabled={ couponApplied }
                                onChange={onCouponInputChange}
                                placeholder={ appliedCouponCode }
                            />
                        </Form.Item>
                        <Button 
                            onClick={ handleValidateCouponCode } 
                            type={'primary'}
                            loading={ couponProcessing }
                            disabled={ ( couponInputValid && cartItems.length && !couponApplied ) ? false : true }
                            className='inline-form-item'
                            style={ { 'marginBottom':'1rem' } }
                        >Apply</Button>
                    </div>
                </Form>
                <div style={ { 'display': ( cartItems.length ) ? 'block' : 'none' } }
                >
                    { couponAlertMarkup }
                </div>
                { cartTotals }
            </div>
        </div>
    )
}

export default CartTotals